import { render, staticRenderFns } from "./management-rams.vue?vue&type=template&id=849f5012"
import script from "./management-rams.vue?vue&type=script&lang=js"
export * from "./management-rams.vue?vue&type=script&lang=js"
import style0 from "./management-rams.vue?vue&type=style&index=0&id=849f5012&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports